import { useTranslation } from 'react-i18next'
import './MobileExtras.css'

function MobileExtras() {
  const { t } = useTranslation()
  const trustItems = [
    { icon: '🏛️', title: t('sidebar.experts'), subtitle: t('sidebar.expertsSub') },
    { icon: '💸', title: t('sidebar.noWin'), subtitle: t('sidebar.noWinSub') },
    { icon: '🤝', title: t('sidebar.commission'), subtitle: t('sidebar.commissionSub') },
    { icon: '➕', title: t('sidebar.followUp'), subtitle: t('sidebar.followUpSub') },
  ]

  return (
    <div className="claimform-mobile-extras">

      <div className="claimform-google-review-container">
        <div className="g-badge">
          <div className="g-badge-placeholder" aria-hidden="true">
            <span className="g-mark">G</span>
            <span>
              <span className="g-badge-stars"><span className="g-score">4.4</span><span className="g-stars">★★★★<span className="g-star-empty">★</span></span></span>
              <span className="g-count">215 Google reviews</span>
            </span>
          </div>
        </div>
      </div>

      <div className="trust-section">
        {trustItems.map((item, index) => (
          <div className="trust-item" key={index}>
            <div className="trust-icon">{item.icon}</div>
            <div className="trust-txt">
              <strong>{item.title}</strong>
              <span>{item.subtitle}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="phone-section">
        <div className="phone-icon">📞</div>
        <div>
          <div className="phone-lbl">{t('mobileExtras.questions')}</div>
          <a href="tel:+4925912539898" className="phone-num">+49 02591 253 98 98</a>
          <div className="phone-hours">{t('mobileExtras.phoneHours')}</div>
        </div>
      </div>
    </div>
  )
}

export default MobileExtras
